'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$TrustSection(quote, name, role) {
  this.iI = null;
  this.iH = null;
  this.iJ = null;
  this.iI = quote;
  this.iH = name;
  this.iJ = role;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$TrustSection as $c_Lio_intela_sites_digitalinternship_data_Segments$TrustSection };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$TrustSection.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$TrustSection;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$TrustSection() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$TrustSection as $h_Lio_intela_sites_digitalinternship_data_Segments$TrustSection };
$h_Lio_intela_sites_digitalinternship_data_Segments$TrustSection.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 90551122, true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$TrustSection) && (((this.iI === x$0.iI) && (this.iH === x$0.iH)) && (this.iJ === x$0.iJ))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "TrustSection";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.iI;
      break;
    }
    case 1: {
      return this.iH;
      break;
    }
    case 2: {
      return this.iJ;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$TrustSection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bM)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$TrustSection as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$TrustSection };
var $d_Lio_intela_sites_digitalinternship_data_Segments$TrustSection = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$TrustSection, "io.intela.sites.digitalinternship.data.Segments$TrustSection", ({
  bM: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$TrustSection as $d_Lio_intela_sites_digitalinternship_data_Segments$TrustSection };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Trust-Section.js.map
